import { CodeV2 as Code } from '@/redux/apis/codes-api';
import { IFormInputs } from '.';

function normalizeArray(array: string[] | undefined): { value: string }[] {
  if (!array || !array.length) return [];
  return array.map((value: string) => ({ value }));
}

function normalizePermissions(permissions: Code['permissions']): string {
  if (!permissions || !permissions.length) return 'public';
  if (permissions.some(({ type }) => type === 'location')) return 'location';
  else if (permissions.every(({ type }) => type === 'user')) return 'private';
  // Default to 'public' if the permissions array is not empty but doesn't contain 'user' or 'location' types -> This is a fallback and should ideally not happen if the data is consistent.
  return 'public';
}

export function normalizeForm(data: Code): IFormInputs {
  return {
    targetUrl: data.targetUrl,
    codeName: data.codeName,
    targetGroup: data.targetGroup,
    showIcon: !!data.icon,
    icon: data.icon,
    communicationPurpose: data.communicationPurpose,
    subcategory: data.subcategory,
    location: {
      country: data.location?.country || '',
      site: data.location?.site || '',
    },
    onlyOnlineUsage: data.onlyOnlineUsage,
    store: {
      component: normalizeArray(data.store?.component),
      department: normalizeArray(data.store?.department),
    },
    permissions: normalizePermissions(data.permissions),
    carrier: {
      type: normalizeArray(data.carrier?.type),
      size: normalizeArray(data.carrier?.size),
    },
  };
}
